import React, { useEffect, useState } from 'react'
import Markdown from './Markdown'
import LoadingSpinner from './LoadingSpinner'
import { policyApi, PolicyKey } from '../api/policy'

/** 관리자에서 편집한 정책 내용을 불러와 마크다운으로 렌더. 실패 시 fallback. */
interface PolicyBodyProps {
  policyKey: PolicyKey
  fallback?: React.ReactNode
}

const PolicyBody: React.FC<PolicyBodyProps> = ({ policyKey, fallback }) => {
  const [content, setContent] = useState<string | null>(null)
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    let alive = true
    policyApi
      .getPolicy(policyKey)
      .then((p) => {
        if (alive) setContent(p.content || null)
      })
      .catch(() => {
        if (alive) setContent(null)
      })
      .finally(() => {
        if (alive) setLoaded(true)
      })
    return () => {
      alive = false
    }
  }, [policyKey])

  if (content) return <Markdown content={content} />
  if (!loaded) {
    return (
      <div className="w-full flex justify-center items-center py-40px">
        <LoadingSpinner size={28} borderWidth={3} />
      </div>
    )
  }
  return (
    <>
      {fallback ?? (
        <p className="font-pretendard text-14px text-textColorText3">
          내용을 불러오지 못했습니다.
        </p>
      )}
    </>
  )
}

export default PolicyBody
